export const ALERTS_STORE_KEY = 'alerts';
export const ALERTS_SERVICE_KEY = 'alerts';
export const ALERTS_API_URL = '/api/v1/alert/';
